export default __webpack_public_path__ + "static/media/google.e12914ad.png";